const e = {
  id: "OregonMegabucks",
  name: "Megabucks",
  style: {
    colorPrimary: "#4d825d"
  }
};
export {
  e as default
};
